import Select from "react-select";

function SectorCategoriesDropdown({
  sectorCategories = [],
  selectedSectorCategory,
  handleSectorCategoryChange,
}) {
  const sectorCategoryOption =
    sectorCategories?.map?.((category) => ({
      value: category?._id,
      label: category?.categoryName,
    })) || [];

  const selectedSectorCategoryOption = sectorCategoryOption?.find?.(
    (category) => category?.value === selectedSectorCategory
  );
const selectWrapperStyle = {
  position: "relative",
  width: "100%",
};

const chevronStyle = {
  position: "absolute",
  right: "12px",
  top: "50%",
  transform: "translateY(-50%) rotate(45deg)",
  width: "10px",
  height: "10px",
  borderRight: "2px solid #1CC3B2",
  borderBottom: "2px solid #1CC3B2",
  pointerEvents: "none",
};
const customSelectStyles = {
  indicatorsContainer: (base) => ({
    ...base,
    display: "none", 
  }),
  control: (base) => ({
    ...base,
    border: "1px solid #E3E8EE",
    background: "#F7FAFC",
    borderRadius: "8px",
    height: "44px",
    paddingRight: "30px",
  }),
};


  return (
    <div style={selectWrapperStyle}>
  <Select
    value={selectedSectorCategoryOption}
    onChange={handleSectorCategoryChange}
    options={sectorCategoryOption}
    styles={customSelectStyles}
  />
  <span style={chevronStyle}></span>
</div>

  );
}

export default SectorCategoriesDropdown;
